import { Gauge, ShieldCheck } from 'lucide-react';
import ProductCard, { ProductCardSkeleton } from './ProductCard';

/**
 * StarterKitFirstStep — "Aanbevolen eerste stap" block.
 * Always renders the measure-first products (P1-uitlezer, energiedashboard,
 * Powersure monitoring, slimme tussenstekker). Frames them as the safe,
 * low-cost first move before any larger hardware decisions.
 */
export default function StarterKitFirstStep({
  loading,
  products,
  onInquiry,
  trustCopy,
  intakeId,
  customerEmail,
}) {
  const items = products || [];

  return (
    <section data-testid="ec-sk-first-step">
      <div className="flex items-start gap-3 mb-3">
        <div className="w-10 h-10 rounded-lg bg-emerald-500/15 flex items-center justify-center flex-shrink-0">
          <Gauge className="w-5 h-5 text-emerald-700" />
        </div>
        <div className="flex-1 min-w-0">
          <h2
            className="text-[20px] sm:text-[22px] font-medium text-primary leading-tight"
            style={{ fontFamily: 'Outfit' }}
            data-testid="ec-sk-first-step-title"
          >
            Aanbevolen eerste stap
          </h2>
          <p className="text-sm text-muted-foreground mt-1" data-testid="ec-sk-first-step-intro">
            Voor de meeste woningen is eerst meten de veiligste en goedkoopste start. Zo
            voorkomt u dat u te snel geld uitgeeft aan producten die misschien niet nodig zijn.
          </p>
        </div>
      </div>

      {loading && items.length === 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-testid="ec-sk-first-step-loading">
          <ProductCardSkeleton />
          <ProductCardSkeleton />
          <ProductCardSkeleton />
        </div>
      ) : items.length === 0 ? (
        <div className="rounded-xl border border-border bg-white p-5 text-sm text-muted-foreground" data-testid="ec-sk-first-step-empty">
          Geen meetproducten gevonden.
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {items.map((p, i) => (
            <ProductCard
              key={p.product_id}
              product={p}
              featured={i === 0}
              tone="first_step"
              onInquiry={onInquiry}
              intakeId={intakeId}
              customerEmail={customerEmail}
            />
          ))}
        </div>
      )}

      {trustCopy && (
        <div
          className="mt-4 flex items-start gap-2 text-sm bg-white border border-emerald-200 rounded-xl px-4 py-3 text-emerald-900"
          data-testid="ec-sk-trust-copy"
        >
          <ShieldCheck className="w-4 h-4 text-emerald-700 mt-0.5 flex-shrink-0" />
          <p className="leading-relaxed">{trustCopy}</p>
        </div>
      )}
    </section>
  );
}
